import { createFileRoute, Outlet } from "@tanstack/react-router";

/** The top-ups: the list, and one top-up's page. */
export const Route = createFileRoute("/_app/money/topups")({
  component: Outlet,
});
